import {
    RaikoBaseCardContainer, RaikoCustomSelect,
    raikoCustomSelectItemGenerator, RaikoSectionContainer,
    showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {useParams} from "react-router-dom";
import {VowService} from "../../../serverService/vow/VowService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {useEffect, useState} from "react";
import {PaymentGatewayService} from "../../../serverService/paymentGatewayService/PaymentGatewayService";

export default function VowDetailGateway() {
    const {id: vowId} = useParams()
    const service = new VowService();
    const paymentService = new PaymentGatewayService();

    const loading = new LoadingHelper(useLoadingDispatcher())
    const [gateways, setGateways] = useState([])
    const [selectedGateway, setSelectedGateway] = useState(-1)

    const [loadingState, setLoadingState] = useState(false)

    useEffect(() => {
        getAvailableGateways()
        getSelectedGateway()
    }, []);

    function getSelectedGateway() {
        service.getVowPayment(vowId)
            .then(response => {
                setSelectedGateway(response.paymentGatewayId)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {

        })
    }

    function getAvailableGateways() {
        loading.show()
        paymentService.getAvailableGateways(0, 20)
            .then(response => {
                setGateways([])
                response.data.map((gateway) => {
                    setGateways(prevState => [
                        ...prevState,
                        raikoCustomSelectItemGenerator(gateway.id, gateway.title)
                    ])
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateGateway() {
        if (selectedGateway !== -1) {
            setLoadingState(true)
            service.updateVowGateway(vowId, selectedGateway)
                .then(response => {
                    showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                }).catch(reason => {
                showServerErrorMessage(reason)
            }).finally(_ => {
                setLoadingState(false)
            })
        }
    }

    return (
        <RaikoBaseCardContainer>
            <RaikoSectionContainer
                title={"مدیریت درگاه پرداخت"}
                hasActionButton
                actionButtonOnclick={handleUpdateGateway}
                actionButtonLoadingState={loadingState}
            >
                <RaikoCustomSelect
                    labelText={"درگاه پرداخت"}
                    value={selectedGateway}
                    setValue={setSelectedGateway}
                    items={gateways}
                />
            </RaikoSectionContainer>
        </RaikoBaseCardContainer>
    )
}